import { ScheduleItem } from "types/response/schedule";

export const getPreviousMap = (
  cleaningSchedules: ScheduleItem[],
  maps: any[],
  currentDate: Date
) => {
  // 設定スケジュールが1つしかない場合、そのスケジュールを直接返す
  if (cleaningSchedules.length === 1) {
    const previousSchedule = cleaningSchedules[0];
    return maps.find((m) => previousSchedule.mapId === m.mapId);
  }
  for (let i = 0; i <= 6; i++) {
    // 当日の清掃予定があるかをチェック。なければ前日以前の予定をとる
    // +7は、剰余結果が正となるよう補正
    const previousSchedule = cleaningSchedules.find(
      (cs) => cs.dayOfWeek === (currentDate.getDay() - i + 7) % 7
    );
    if (!previousSchedule) {
      continue; // previousScheduleがない場合、次のiの値でループを続行
    }
    //前日以前の予定をとった場合は、それが前回清掃マップとなるため設定してループを抜ける
    if (previousSchedule.dayOfWeek !== currentDate.getDay()) {
      const previousMap = maps.find((m) => previousSchedule?.mapId === m.mapId);
      return previousMap;
    }
    // 当日と同じ予定の場合、現在時刻と清掃予定時刻を比較。清掃前であれば、前日以前の予定を取りに行く。
    // 清掃後であれば、それが前回清掃マップとなるため設定してループを抜ける
    // 比較した結果が同じ場合、清掃未実施として前日以前の予定を取りに行く
    if (
      currentDate.getHours() * 1000 + currentDate.getMinutes() <=
      previousSchedule.hour * 1000 + previousSchedule.minute
    ) {
      continue; //清掃前の場合、次のiの値でループを続行
    } else {
      const previousMap = maps.find((m) => previousSchedule?.mapId === m.mapId);
      return previousMap;
    }
  }
};

// 次回清掃マップを見つける
export const getCurrentMap = (
  cleaningSchedules: ScheduleItem[],
  maps: any[],
  currentDate: Date
) => {
  let currentMap;
  // 設定スケジュールが1つしかない場合、そのスケジュールを直接返す
  if (cleaningSchedules.length === 1) {
    const currentSchedule = cleaningSchedules[0];
    currentMap = maps.find((m) => currentSchedule.mapId === m.mapId);
  } else {
    for (let i = 0; i <= 6; i++) {
      // 当日以降の清掃予定を取得する。見つからなければ翌日以降も探して取得
      const currentSchedule = cleaningSchedules.find(
        (s) => s.dayOfWeek === (currentDate.getDay() + i) % 7
      );
      //翌日以降の予定であればそれが次回清掃予定のため、設定してループを抜ける
      if (currentSchedule) {
        if (currentSchedule.dayOfWeek !== currentDate.getDay()) {
          currentMap = maps.find((m) => currentSchedule?.mapId === m.mapId);
          break;
          // 当日と同じ予定の場合、現在時刻と清掃予定時刻を比較。清掃前であれば、それが次回清掃予定のため設定してループを抜ける。
          // 清掃後であれば、翌日以降の清掃予定を取りに行く
          // 時間*1000+分の4桁数値にして比較。結果同じ時間だった場合は、次回清掃予定とみなしてループ抜け
        } else if (
          currentDate.getHours() * 1000 + currentDate.getMinutes() <=
          currentSchedule.hour * 1000 + currentSchedule.minute
        ) {
          currentMap = maps.find((m) => currentSchedule?.mapId === m.mapId);
          break;
        }
      }
    }
  }
  return currentMap;
};
